import React from "react";
import { withTranslation } from "react-i18next";
import Upload from "../utilis/imagesHelper/uploader";
import Avatar from "../images/avatar.png";

class UploadImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            src: Avatar,
            uploaded: false
        };

        this.on = {
            change: (file, src) => {
                this.setState({ src, uploaded: true }, () => {
                    if (typeof this.props.onChange === "function") {
                        this.props.onChange(file);
                    }
                });
            }
        };
    }

    render() {
        const { t } = this.props;

        return (
            <section className="text-gray-700 body-font">
                <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
                    <div style={{ background: "#fff" }} className="lg:max-w-lg lg:w-full md:w-1/2 w-4/6 mb-10 md:mb-0">
                        <img style={{ maxWidth: "100%" }} className="object-cover object-center rounded" alt="hero" src={this.state.src} />
                    </div>
                    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
                        <div className="flex justify-center">
                            <Upload onChange={this.on.change} />
                            {this.state.uploaded ? (
                                <button
                                    onClick={this.props.onSubmit}
                                    className="sm:w-12/12 ml-4 block text-white bg-blue-900 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                                >
                                    {t("submit")}
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withTranslation()(UploadImage);
